module.exports = __webpack_public_path__ + "img/user-shakespeare.f6d6ca0d.svg";